import { fillInpageAnchors, selectChoice, selectedTitle } from "#/admin/legacy/page-builder/link-dialog.js";
import { settleMount } from "#ce/framework/mount-ready";

class InternalAnchors {
  constructor(selectElement) {
    this.select = selectElement?.nodeType ? selectElement : selectElement?.[0];
    this.initializeItems();
  }

  get value() {
    return this.select.value || "";
  }

  set value(val) {
    val = val.replace("#", "");
    this.requestedValue = val;
    selectChoice(this.select, val);
  }

  get defaultTitle() {
    return selectedTitle(this.select);
  }

  async initializeItems() {
    if (!(await settleMount(this.select))) {
      return;
    }

    fillInpageAnchors(this.select, this.get(), this.requestedValue);
  }

  get() {
    let pbSections = Sparkle.PageBuilder.Section.instances;
    return Object.keys(pbSections)
      .map((section) => {
        return this.getComponents(pbSections[section].components);
      })
      .flat();
  }

  getComponents(section) {
    return section.map((component) => {
      return { elementId: component.anchorWithDefault(), label: component.getLabel() };
    });
  }
}

window.InternalAnchors = InternalAnchors;
